import { getSupabaseClient } from './supabaseClient';
import type { ProjectCard, ProjektRow } from '../types';

function rowToCard(row: ProjektRow): ProjectCard {
  return {
    id: row.id,
    title: row.title,
    description: row.description,
    image: row.image,
    links: row.link_demo ? { demo: row.link_demo } : {},
  };
}

export async function fetchProjekty(): Promise<ProjectCard[]> {
  const supabase = getSupabaseClient();
  if (!supabase) {
    throw new Error(
      'Supabase není nakonfigurován (chybí REACT_APP_SUPABASE_URL nebo REACT_APP_SUPABASE_PUBLISHABLE_KEY).',
    );
  }

  const { data, error } = await supabase
    .from('projekty')
    .select('id, title, description, image, link_demo, sort_order')
    .order('sort_order', { ascending: true });

  if (error) {
    throw error;
  }

  return (data as ProjektRow[]).map(rowToCard);
}
